// eslint-disable-next-line import/prefer-default-export
export const LONG_GRASS_TYPE = {
  LGF: 'long_grass_fee',
  LGQ: 'long_grass_quote',
};

export const GRASS_HEIGHTS = {
  ABOVE_25: '25above',
  BETWEEN_6_TO_12: '6to12',
  BETWEEN_13_TO_18: '13to18',
  BETWEEN_19_TO_24: '19to24',
  BETWEEN_9_TO_15: '9to15',
  BETWEEN_16_TO_21: '16to21',
  ABOVE_22: '22above',
};
